import React from 'react';

const EditorOnnetwork = props => {

	// render
	return (
		<div>
			{props.children}
			<div className="form-group">
				<label className="col-sm-3 control-label">Onnetwork Playlist ID</label>
				<div className="col-sm-9">
					<input type="text" name="playlist_id" className="form-control" defaultValue={props.settings.playlist_id} placeholder="MCwxNng5LDMsMjAsMzExLDEwODcsMSwwLDEsMTAsMCwwLDEsMCwxLDEsMCwwLDAsMA==" />
				</div>
			</div>
		</div>
	);
}


export default EditorOnnetwork;